@if (businessCardData) {
  @if (businessCardData.templateId === 'template-1') {
    <app-template1 [businessCardData]="businessCardData" [businessCardLoader]="isLoading"></app-template1>
  } @else if (businessCardData.templateId === 'template-2') {
    <app-template2 [businessCardData]="businessCardData" [businessCardLoader]="isLoading"></app-template2>
  } @else if (businessCardData.templateId === 'template-3') {
    <app-template3 [businessCardData]="businessCardData" [businessCardLoader]="isLoading"></app-template3>
  }
} @else {
  <router-outlet></router-outlet>
}
